import type { QuestionTypeConfig, QuestionType, AcademicLevel } from "./types";

export const questionTypes: QuestionTypeConfig[] = [
  {
    id: "multiple-choice",
    name: "Multiple Choice",
    description: "Select the correct answer from 4 options",
    applicableLevels: [
      "class-1", "class-2", "class-3", "class-4", "class-5",
      "class-6", "class-7", "class-8", "class-9", "class-10",
      "class-11", "class-12", "jee-foundation", "jee-main", "jee-advanced",
      "neet", "state-competitive", "elementary", "middle-school",
      "grade-9", "grade-10", "grade-11", "grade-12", "ap-level",
      "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
  {
    id: "short-answer",
    name: "Short Answer",
    description: "Brief written response (1-3 sentences or expressions)",
    applicableLevels: [
      "class-3", "class-4", "class-5", "class-6", "class-7", "class-8",
      "class-9", "class-10", "class-11", "class-12", "jee-foundation",
      "jee-main", "jee-advanced", "neet", "state-competitive",
      "middle-school", "grade-9", "grade-10", "grade-11", "grade-12",
      "ap-level", "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
  {
    id: "numerical-answer",
    name: "Numerical Answer",
    description: "Enter a number (integer, decimal, fraction, or expression)",
    applicableLevels: [
      "class-1", "class-2", "class-3", "class-4", "class-5",
      "class-6", "class-7", "class-8", "class-9", "class-10",
      "class-11", "class-12", "jee-foundation", "jee-main", "jee-advanced",
      "neet", "state-competitive", "elementary", "middle-school",
      "grade-9", "grade-10", "grade-11", "grade-12", "ap-level",
      "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
  {
    id: "fill-in-the-blank",
    name: "Fill in the Blank",
    description: "Complete the mathematical statement or equation",
    applicableLevels: [
      "class-1", "class-2", "class-3", "class-4", "class-5",
      "class-6", "class-7", "class-8", "class-9", "class-10",
      "class-11", "class-12", "elementary", "middle-school",
      "grade-9", "grade-10", "grade-11", "grade-12", "college", "undergraduate"
    ],
  },
  {
    id: "true-false",
    name: "True / False",
    description: "Determine if a mathematical statement is true or false",
    applicableLevels: [
      "class-1", "class-2", "class-3", "class-4", "class-5",
      "class-6", "class-7", "class-8", "class-9", "class-10",
      "class-11", "class-12", "elementary", "middle-school",
      "grade-9", "grade-10", "grade-11", "grade-12", "college", "undergraduate"
    ],
  },
  {
    id: "problem-solving",
    name: "Problem Solving",
    description: "Multi-step problems requiring reasoning and strategy",
    applicableLevels: [
      "class-3", "class-4", "class-5", "class-6", "class-7", "class-8",
      "class-9", "class-10", "class-11", "class-12", "jee-foundation",
      "jee-main", "jee-advanced", "neet", "state-competitive",
      "middle-school", "grade-9", "grade-10", "grade-11", "grade-12",
      "ap-level", "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
  {
    id: "word-problem",
    name: "Word Problem",
    description: "Real-world scenarios requiring mathematical modeling",
    applicableLevels: [
      "class-2", "class-3", "class-4", "class-5", "class-6", "class-7", "class-8",
      "class-9", "class-10", "class-11", "class-12", "jee-foundation",
      "jee-main", "jee-advanced", "state-competitive",
      "elementary", "middle-school", "grade-9", "grade-10", "grade-11", "grade-12",
      "ap-level", "college", "undergraduate", "graduate"
    ],
  },
  {
    id: "proof",
    name: "Proof",
    description: "Construct a rigorous mathematical proof",
    applicableLevels: [
      "class-10", "class-11", "class-12", "jee-advanced",
      "grade-10", "grade-11", "grade-12", "ap-level",
      "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
  {
    id: "derivation",
    name: "Derivation",
    description: "Derive a formula or result from first principles",
    applicableLevels: [
      "class-11", "class-12", "jee-advanced",
      "grade-11", "grade-12", "ap-level",
      "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
  {
    id: "calculation",
    name: "Calculation",
    description: "Compute a specific numerical or symbolic result",
    applicableLevels: [
      "class-1", "class-2", "class-3", "class-4", "class-5",
      "class-6", "class-7", "class-8", "class-9", "class-10",
      "class-11", "class-12", "jee-foundation", "jee-main", "jee-advanced",
      "neet", "state-competitive", "elementary", "middle-school",
      "grade-9", "grade-10", "grade-11", "grade-12", "ap-level",
      "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
  {
    id: "conceptual",
    name: "Conceptual",
    description: "Test understanding of mathematical concepts and relationships",
    applicableLevels: [
      "class-3", "class-4", "class-5", "class-6", "class-7", "class-8",
      "class-9", "class-10", "class-11", "class-12", "jee-foundation",
      "jee-main", "jee-advanced", "state-competitive",
      "middle-school", "grade-9", "grade-10", "grade-11", "grade-12",
      "ap-level", "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
  {
    id: "mixed",
    name: "Mixed",
    description: "Random mix of different question types",
    applicableLevels: [
      "class-3", "class-4", "class-5", "class-6", "class-7", "class-8",
      "class-9", "class-10", "class-11", "class-12", "jee-foundation",
      "jee-main", "jee-advanced", "neet", "state-competitive",
      "middle-school", "grade-9", "grade-10", "grade-11", "grade-12",
      "ap-level", "college", "undergraduate", "graduate", "postgraduate", "advanced"
    ],
  },
];

export function getQuestionType(id: QuestionType): QuestionTypeConfig | undefined {
  return questionTypes.find((q) => q.id === id);
}

export function getQuestionTypesForLevel(level: AcademicLevel): QuestionTypeConfig[] {
  return questionTypes.filter((q) => q.applicableLevels.includes(level));
}

export function getQuestionTypeNames(): { id: QuestionType; name: string; description: string }[] {
  return questionTypes.map((q) => ({ id: q.id, name: q.name, description: q.description }));
}